export default "__VITE_ASSET__C5oM1usK__"